<div class="w-full h-full" *ngIf="isPageReady">
  <div class="flex flex-col gap-3">
    <!-- Row 1: Salutation + First Name + Middle + Last Name -->
    <div class="grid grid-cols-12 gap-3">
      <qb-field label="Salutation" class="col-span-6 lg:col-span-1">
        <input type="text" pInputText autocomplete="off" [pAutoFocus]="autoFocus"
          [(ngModel)]="proximityUser!.salutation" [bzModel]="proximityUser!" [disabled]="isReadOnly"
          name="salutation" />
      </qb-field>
      <qb-field label="First Name" class="col-span-6 lg:col-span-5">
        <input type="text" pInputText autocomplete="off" [(ngModel)]="proximityUser!.firstName"
          [bzModel]="proximityUser!" [disabled]="isReadOnly" name="firstName" (blur)="onFirstNameBlur()" />
      </qb-field>
      <qb-field label="Middle" class="col-span-6 lg:col-span-1">
        <input type="text" pInputText autocomplete="off" [(ngModel)]="proximityUser!.middleName"
          [bzModel]="proximityUser!" [disabled]="isReadOnly" name="middleName" />
      </qb-field>
      <qb-field label="Last Name" class="col-span-6 lg:col-span-5">
        <input type="text" pInputText autocomplete="off" [(ngModel)]="proximityUser!.lastName"
          [bzModel]="proximityUser!" [disabled]="isReadOnly" name="lastName" (blur)="updateUserNameDeps()" />
      </qb-field>
    </div>
    <!-- Row 2: Title (4) + Gender (2) + E-Mail (6) -->
    <div class="grid grid-cols-12 gap-3">
      <qb-field label="Title" class="col-span-6 lg:col-span-4">
        <input type="text" pInputText [(ngModel)]="proximityUser!.title" [bzModel]="proximityUser!"
          [disabled]="isReadOnly" name="title" />
      </qb-field>
      <qb-field *ngIf="genders && genderModel" label="Gender" class="col-span-6 lg:col-span-2">
        <!-- <p-dropdown [options]="genders" [(ngModel)]="genderModel.genderId" optionLabel="name" optionValue="id"
          [disabled]="isReadOnly" name="genderId"></p-dropdown> -->
        <p-select [options]="genders" [(ngModel)]="genderModel.genderId" optionLabel="name" optionValue="id"
          [disabled]="isReadOnly" name="genderId" class="w-full"></p-select>
      </qb-field>
      <qb-field label="E-Mail" class="col-span-6 lg:col-span-6">
        <div class="flex items-center gap-2">
          <input type="text" pInputText [(ngModel)]="proximityUser!.email" [bzModel]="proximityUser!"
            [disabled]="isReadOnly || !isBeingAdded" name="email" class="flex-1" (blur)="onEmailBlur()" />
          <!-- Change-email entry point. Only shows on edit forms for authorized roles
               when the form has no pending changes — keeps this off the normal save path. -->
          <a *ngIf="canChangeEmail" href="javascript:void(0)" (click)="onChangeEmailClick()"
            class="bluelink text-sm whitespace-nowrap">
            Change...
          </a>
        </div>
        <!-- Optional slot for the parent to project a contextual link (e.g. the
             account-user add-mode "Existing user: <link>" lookup result). Parents
             that don't project anything see no change. -->
        <ng-content select="[emailExtra]"></ng-content>
      </qb-field>
    </div>
    <!-- Row 3: Login Name (6) + Hire Date (3) + Created on (3) -->
    <div class="grid grid-cols-12 gap-3">
      <qb-field label="Login Name" class="col-span-6 lg:col-span-6">
        <!-- Username is system-assigned (FirstName initial + LastName, sequenced if it collides).
             Disabled in both add and edit modes — never directly editable. See
             UserFrmComponent.findUniqueUserName for the auto-suggest logic. -->
        <input type="text" pInputText [(ngModel)]="proximityUser!.username" [bzModel]="proximityUser!"
          name="username" disabled />
      </qb-field>
      <qb-field label="Hire Date" class="col-span-6 lg:col-span-3">
        <p-datepicker [(ngModel)]="proximityUser!.hireDate" [bzModel]="proximityUser!" name="hireDate"
          [disabled]="isReadOnly" [showIcon]="true" inputId="buttondisplay" [showOnFocus]="false" appendTo="body" />
      </qb-field>
      <qb-field label="Created on" class="col-span-6 lg:col-span-3">
        <p-datepicker [showTime]="true" [disabled]="true" [ngModel]="proximityUser!.crtnTs" [bzModel]="proximityUser!"
          name="crtnTs"></p-datepicker>
      </qb-field>
    </div>
    <!-- Row 4: Telephone (4) + Ext (2) + Mobile (4) + Accept SMS checkbox (2) -->
    <div class="grid grid-cols-12 gap-3">
      <qb-field label="Telephone" class="col-span-6 lg:col-span-4">
        <input type="text" pInputText autocomplete="off" [(ngModel)]="proximityUser!.telephoneNumber"
          [bzModel]="proximityUser!" [disabled]="isReadOnly" name="telephoneNumber" />
      </qb-field>
      <qb-field label="Ext." class="col-span-6 lg:col-span-2">
        <input type="text" pInputText autocomplete="off" [(ngModel)]="proximityUser!.extension"
          [bzModel]="proximityUser!" [disabled]="isReadOnly" name="extension" />
      </qb-field>
      <qb-field label="Mobile" class="col-span-6 lg:col-span-4">
        <input type="text" pInputText autocomplete="off" [(ngModel)]="proximityUser!.cellNumber"
          [bzModel]="proximityUser!" [disabled]="isReadOnly" name="cellNumber" />
      </qb-field>
      <div class="col-span-6 lg:col-span-2 flex items-center justify-center gap-2 mt-6">
        <p-checkbox [(ngModel)]="proximityUser!.acceptSms" [binary]="true" [disabled]="isReadOnly" name="acceptSms"
          inputId="acceptSms"></p-checkbox>
        <label for="acceptSms">Accept SMS?</label>
      </div>
    </div>
    <!-- Row 5: Role (if available) -->
    <div *ngIf="roles" class="grid grid-cols-12 gap-3">
      <qb-field label="Role" class="col-span-6 lg:col-span-6">
        <!-- <p-dropdown [options]="roles" [(ngModel)]="proximityUser.proximityRoleId" optionLabel="name" optionValue="id"
          [disabled]="isReadOnly" name="roleId"></p-dropdown> -->
        <p-select [options]="roles" [(ngModel)]="proximityUser.proximityRoleId" optionLabel="name" optionValue="id"
          [disabled]="isReadOnly" name="roleId" class="w-full"></p-select>
      </qb-field>
    </div>
  </div>
</div>